/// <amd-module name="Artifacts/FeedSettings/helpers/PermissionsHelpers" />

import { FeedPermission, FeedRole } from "Artifacts/Root/web-apis/contracts/Feed";

/**
 * Filters out permission that aren't required for UI
 * @param permissions - list of permissions set to feed
 */
export function filterWellKnownPermissions(permissions: FeedPermission[]): FeedPermission[] {
  return permissions.filter((permission: FeedPermission) => {
    return (
      permission.role === FeedRole.Administrator ||
      permission.role === FeedRole.Contributor ||
      permission.role === FeedRole.Collaborator ||
      permission.role === FeedRole.Reader
    );
  });
}

export function getViewPermissionsDelta(
  currentViewPermissions: FeedPermission[],
  permissionsToUpdate: FeedPermission[],
): {
  permissionsToRetain: FeedPermission[];
  permissionsToAdd: FeedPermission[];
  permissionsToDelete: FeedPermission[];
} {
  const permissionsToRetain: FeedPermission[] = [];
  const permissionsToAdd: FeedPermission[] = [];
  const permissionsToDelete: FeedPermission[] = [];

  const viewPermissionsSet = new Set<string>();
  const permissionsToUpdateSet = new Set<string>();
  if (permissionsToUpdate) {
    permissionsToUpdate.forEach((permission: FeedPermission) => {
      permissionsToUpdateSet.add(permission.identityId);
    });
  }

  if (currentViewPermissions) {
    currentViewPermissions.forEach((permission: FeedPermission) => {
      viewPermissionsSet.add(permission.identityId);

      if (permissionsToUpdateSet.has(permission.identityId)) {
        permissionsToRetain.push(permission);
        return;
      }

      permissionsToDelete.push(permission);
    });
  }

  if (permissionsToUpdate) {
    permissionsToUpdate.forEach((permission: FeedPermission) => {
      if (viewPermissionsSet.has(permission.identityId)) {
        // existing or deleted, already captured
        return;
      }

      permissionsToAdd.push(permission);
    });
  }

  return { permissionsToRetain, permissionsToAdd, permissionsToDelete };
}
